import { createFileRoute, redirect } from '@tanstack/react-router'
import { JournalEntryDetailScreen } from '@/features/accounting/journal-entry-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one journal entry (plans/58 D-14).
 *
 * The grant pair is the register route's own: reading the ledger needs only
 * `accounting_report.view`, posting needs `accounting_journal.create`, and
 * `JournalEntryPolicy::viewAny` allows either — so this page and the list
 * agree on who gets in. Whether THIS entry may be seen is the API's answer;
 * an id outside the recent-200 window renders the not-found branch.
 */
export const Route = createFileRoute('/_authenticated/accounting/journal/$entryId')({
  beforeLoad: ({ context }) => {
    if (
      !hasGrant(context.queryClient, 'accounting_journal.create') &&
      !hasGrant(context.queryClient, 'accounting_report.view')
    ) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: JournalEntryDetailRoute,
})

function JournalEntryDetailRoute() {
  const { entryId } = Route.useParams()

  return <JournalEntryDetailScreen entryId={entryId} />
}
